// Shared Tailwind-token class strings for onboarding step content.
// Replaces the bespoke `.onboarding-step__*` / `.onboarding-card p|ul|li`
// rules that previously lived in onboarding.css.

export const stepTitleClass =
  'm-0 mb-2.5 font-display text-2xl font-bold leading-[1.1] tracking-[-0.02em] text-secondary [text-shadow:var(--glow-gold-text)]';

const bodyText = 'text-sm leading-normal text-[color:var(--text-secondary)]';

export const stepLeadClass = `m-0 mb-3 ${bodyText}`;

export const stepBodyClass = `m-0 ${bodyText}`;

export const stepListClass = `my-2.5 list-disc pl-4 ${bodyText} [&>li]:mb-1`;

export const stepFootnoteClass = 'mt-3 text-sm text-muted-foreground';

export const stepLinkClass =
  'text-[color:var(--nq-blue-bright)] underline underline-offset-[3px] transition-colors hover:text-secondary';

export const stepLinkSecondaryClass =
  'text-muted-foreground underline underline-offset-[3px] transition-colors hover:text-[color:var(--text-secondary)]';
